module.exports = __webpack_public_path__ + "static/media/GrabWebIcon-v1.7.0.16327be8.woff";